import { shuffle } from 'lodash';
import { getApiRoute } from '../../config';
import http from '@/api/http';


export default {
  getRoute(env) {
    const gcmRoutes = getApiRoute('gcmApi', env);
    const shuffleRoutes = () => shuffle(gcmRoutes);
    const api = `${shuffleRoutes()[0]}/get-lb`;

    return http.get(api)
      .then(response => response.data);
  },
};
